import {
  PRICES_SEARCH,
  PRICES_CALCULATE,
  PRICES_UPDATE,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestPricesSearch = async (manufacturerId) => (
  request.get(PRICES_SEARCH, { params: { manufacturer_id: manufacturerId } })
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)

export const requestPricesCalculation = async (params) => (
  request.get(PRICES_CALCULATE, { params })
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)

export const requestPricesUpdate = async (params) => (
  request.patch(PRICES_UPDATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)
